import React from 'react';
import { Bars3Icon, BellIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../hooks/useAuth';

const TopBar = ({ setSidebarOpen }) => {
  const { user } = useAuth();
  
  return (
      <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-mint bg-darkGreen px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-white lg:hidden"
        onClick={() => setSidebarOpen(true)}
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </button>

      {/* Separator */}
      <div className="h-6 w-px bg-mint lg:hidden" aria-hidden="true" />
      
      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="flex items-center gap-x-4 lg:gap-x-6 ml-auto">
          <button
            type="button"
            className="-m-2.5 p-2.5 text-white hover:text-primary-500"
          >
            <span className="sr-only">View notifications</span>
            <BellIcon className="h-6 w-6" aria-hidden="true" />
          </button>

          {/* Separator */}
          <div
            className="hidden lg:block lg:h-6 lg:w-px lg:bg-mint"
            aria-hidden="true"
          />

          {/* Profile dropdown */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="relative">
                <span className="absolute inset-0 rounded-full shadow-inner" aria-hidden="true" />
                <div className="relative h-8 w-8 rounded-full bg-primary-500 flex items-center justify-center text-white font-medium uppercase">
                  {user?.firstName?.charAt(0) || '?'}{user?.lastName?.charAt(0) || '?'}
                </div>
              </div>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-white">
                {user?.firstName} {user?.lastName}
              </p>
              <p className="text-xs font-medium text-mint">
                {user?.role === 'SUPER_ADMIN' ? 'Super Admin' : user?.role === 'COMPANY_ADMIN' ? 'Company Admin' : 'User'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
